import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import App from "./App";
import "./index.css";
import { ANALYTICS_CONFIG } from "./config/analyticsConfig";

// Initialize Google Analytics
if (ANALYTICS_CONFIG.enabled) {
  ReactGA.initialize(ANALYTICS_CONFIG.measurementId, {
    gtagOptions: {
      debug_mode: ANALYTICS_CONFIG.isDevelopment,
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);